import { ElevenChatVoice } from './ElevenslabAssistant';
import './ChatAssistant.scss';
import { ChatHistory } from './ChatHistory';
import { useContext, useEffect, useState } from 'react';
import { Conversation, useGetConversations } from '../api/getConversation';
import { useAuth } from '@/lib/auth';
import Lottie from 'lottie-react';
import appCompoLoading from '@/assets/animation/loading.json';
import { UserContext } from '@/routes';
import { useDeleteConversation } from '../api/deleteConversation';
import { showNotification } from '@/utils/notificationUtils';

// Dummy data
export type ConversationDetail = {
  conversationId: string;
  chatType: 'chat' | 'call' | 'view';
};
export const ChatAssistantV1 = () => {
  const userContext = useContext(UserContext);
  const { user } = useAuth();
  const conversationsMutation = useGetConversations();
  const deleteConversationMutation = useDeleteConversation();
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [chatLoaded, setChatLoaded] = useState(true);
  const [showHistory, setShowHistory] = useState(false);
  const [selectedConvesationDetails, setSelectedConvesationDetails] =
    useState<ConversationDetail>();
  const [conversations, setConversations] = useState<Conversation[]>([]);
  const showEmily =
    user?.permissions?.emily && user?.permissions?.emily?.showMenu === true ? true : false;

  useEffect(() => {
    if (showEmily) {
      fetchConversations();
    } else {
      setInitialDataLoaded(true);
    }
  }, []);

  const fetchConversations = async () => {
    if (!showEmily) {
      return;
    }
    try {
      const response = await conversationsMutation.mutateAsync({
        agent_id: process.env.REACT_APP_ELEVENS_LAB_AGENT_ID || '',
        user_id: user ? `${user?.id}-${user?.businessId}` : undefined,
      });
      setConversations(response.conversations);
      setInitialDataLoaded(true);
    } catch (error) {
      console.error('Failed to fetch conversations:', error);
    }
  };

  const handleDeleteConversation = async (conversationId: string) => {
    try {
      await deleteConversationMutation.mutateAsync(conversationId);
      fetchConversations();
    } catch (error) {
      console.error('Failed to delete conversation:', error);
    }
  };

  return initialDataLoaded ? (
    <div className="container-bg ai-assistant">
      <div
        className={`content-wrapper w-full h-full ${
          chatLoaded || (!chatLoaded && conversations.length == 0) ? 'chat-loaded' : ''
        }`}
      >
        <div
          className={`left-section-assistant ${
            userContext?.isLandscape || !showHistory ? '' : 'd-none'
          }`}
        >
          <ElevenChatVoice
            conversationDetail={selectedConvesationDetails}
            onChatLoaded={(chatLoaded) => {
              setChatLoaded(chatLoaded);
              setShowHistory(false);
              if (!chatLoaded) {
                setTimeout(() => {
                  fetchConversations();
                }, 500);
              }
            }}
            onClearChat={() => {
              setSelectedConvesationDetails(undefined);
              setChatLoaded(false);
              setTimeout(() => {
                fetchConversations();
              }, 500);
            }}
            showHistory={() => {
              setShowHistory(true);
            }}
          />
        </div>

        {!chatLoaded && conversations.length > 0 && (userContext?.isLandscape || showHistory) && (
          <div
            className={`right-section-assistant ${
              userContext?.isLandscape ? 'landscape' : 'portrait'
            }`}
          >
            <ChatHistory
              conversations={conversations}
              onBack={() => setShowHistory(false)}
              onConversationSelected={(conversationDetails: ConversationDetail) => {
                setSelectedConvesationDetails(conversationDetails);
              }}
              onDeleteConversation={handleDeleteConversation}
            />
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className="h-full w-full flex items-center justify-center loader-animation-user">
      <Lottie className="hw-60" animationData={appCompoLoading} />
    </div>
  );
};
